'use strict';

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { LatestListingsClient } from './components/LatestListingsClient';

/**
 * Client-only wrapper for LatestListings.
 *
 * Renders null on server and during initial hydration to avoid mismatch,
 * then mounts the client component which handles data fetching via React Query.
 */
export const LatestListings = ({ userID, layoutItemCount }) => {
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    if (!isMounted) return null;

    return (
        <div className="tw-w-full">
            <LatestListingsClient userID={userID} layoutItemCount={layoutItemCount} />
        </div>
    );
};

LatestListings.propTypes = {
    userID: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null, undefined])]),
    layoutItemCount: PropTypes.number
};
